<template>
  <component :is="type" v-bind="linkProps(to)">
    <slot />
  </component>
</template>

<script>
import { isExternal } from '@/utils/validate';
import { mapGetters } from 'vuex';

export default {
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      specialURL: [
        {
          vUrl: '/user-manager/integral-manage',
          rcUrl: '/rc-standard-business/user-manager/integral-manage',
        },
        {
          vUrl: '/user-manager/member-level',
          rcUrl: '/rc-standard-business/user-manager/member-level',
        },
        {
          vUrl: '/user-manager/member-rights',
          rcUrl: '/rc-standard-business/user-manager/member-rights',
        },
        {
          vUrl: '/distribution/goods-market',
          rcUrl: '/rc-standard-business/distribution/goods-market',
        },
        {
          vUrl: '/distribution/goods-change',
          rcUrl: '/rc-standard-business/distribution/goods-change',
        },
        {
          vUrl: '/distribution/price-handle',
          rcUrl: '/rc-standard-business/distribution/price-handle',
        },
        {
          vUrl: '/good-manage/goods-brand',
          rcUrl: '/rc-standard-business/goods-manage/goods-brand',
        },
        {
          vUrl: '/good-manage/commodity-management',
          rcUrl: '/rc-standard-business/commodity-management/announcement',
        },
        {
          vUrl: '/shop-decoration/channel-manage',
          rcUrl: '/rc-standard-business/shop-decoration/channel-manage',
        },
        {
          vUrl: '/shop-remote/shop-remote-info',
          rcUrl: '/r-linkmall-business/shop-remote-info',
        },
        {
          vUrl: '/shop-remote/shop-remote-info',
          rcUrl: '/r-linkmall-business/shop-remote-info',
        },
        {
          vUrl: '/cpc-ads/delivery-channel',
          rcUrl: '/rc-standard-business/cpc-ads/delivery-channel',
        },
        {
          vUrl: '/cpc-ads/delivery-link',
          rcUrl: '/rc-standard-business/cpc-ads/delivery-link',
        },
        {
          vUrl: '/supplier-account',
          rcUrl: '/rc-standard-business/supplier/myaccount/home',
        },
        {
          vUrl: '/distribution/distributor-account',
          rcUrl: '/rc-standard-business/distribution/myaccount/home',
        },
        {
          vUrl: '/distribution/orders',
          rcUrl: '/rc-standard-business/distribution/orders',
        },
        {
          vUrl: '/shop-decoration/shop-list',
          rcUrl: '/rc-standard-business/shopinfo/decoration',
        },
        {
          vUrl: '/shop-set/auth_manage',
          rcUrl: '/rc-standard-business/shop-set/auth_manage',
        },
        {
          vUrl: '/marketing-manager/special-list',
          rcUrl: '/rc-standard-business/shopinfo/special',
        },
        {
          vUrl: '/order/config',
          rcUrl: '/rc-standard-business/order/config'
        },
        {
          vUrl: '/store-distribute/saleslist',
          rcUrl: '/r-linkmall-business/multilanguage/pages/market/sales/saleslist',
        },
        {
          vUrl: '/store-distribute/salesgoods',
          rcUrl: '/r-linkmall-business/multilanguage/pages/market/sales/salesgoods',
        },
        {
          vUrl: '/store-distribute/salesorder',
          rcUrl: '/r-linkmall-business/multilanguage/pages/market/sales/order',
        },
        {
          vUrl: '/store-distribute/saleswithdraw',
          rcUrl: '/r-linkmall-business/multilanguage/pages/market/sales/withdrawcash',
        },
        {
          vUrl: '/store-distribute/salesconfig',
          rcUrl: '/r-linkmall-business/multilanguage/pages/market/sales/setter',
        },
        {
          vUrl: '/shop-decoration/suspension',
          rcUrl: '/rc-standard-business/shop-decoration/suspension',
        },
        {
          vUrl: '/marketing-manager/advertModaLlist',
          rcUrl: '/rc-standard-business/shop-decoration/advertModal/list',
        },
      ],
    };
  },
  computed: {
    ...mapGetters(['sellerDecorateGrayHit', 'sellerDecorateForwardInit']),
    isExternal() {
      return isExternal(this.to);
    },
    isRcLink() {
      // 在specialURL里面的链接，除了装修列表和专题列表需要二次判断，其他都直接跳转到rc即可
      // 二次判断: sellerDecorateGrayHit新装修灰度开关为true && sellerDecorateForwardInit 新装修引导为true
      const _specialURL =
        this.specialURL
          .map(
            item =>
              item.vUrl !== '/shop-decoration/shop-list' &&
              item.vUrl !== '/marketing-manager/special-list' &&
              item.vUrl
          )
          ?.filter(_item => !!_item) || [];
      const grayFlag =
        this.sellerDecorateGrayHit && this.sellerDecorateForwardInit;
      return (
        _specialURL.includes(this.to) ||
        (grayFlag && this.to === '/shop-decoration/shop-list') ||
        (grayFlag && this.to === '/marketing-manager/special-list')
      );
    },
    type() {
      if (this.isExternal || this.isRcLink) {
        return 'a';
      }
      return 'router-link';
    },
  },
  methods: {
    linkProps(to) {
      const _to = this.isRcLink
        ? this.specialURL.find(item => item.vUrl === this.to)?.rcUrl
        : to;
      if (this.isExternal || this.isRcLink) {
        return {
          href: _to,
          ...(this.isExternal ? { target: '_blank' } : {}),
          rel: 'noopener',
        };
      }
      return {
        to: _to,
      };
    },
  },
};
</script>
